import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "@/lib/backendUrl";
import { Link } from "react-router-dom";
import axios from "axios";
import { Flame, TrendingUp, Music4 } from "lucide-react";

const API = `${BACKEND_URL}/api`;

export default function TrendingSets() {
  const [sets, setSets] = useState([]);

  useEffect(() => {
    axios.get(`${API}/sets/trending`).then(r => setSets(r.data)).catch(() => {});
  }, []);

  if (sets.length === 0) return null;

  const fmt = (s) => `${String(Math.floor((s || 0) / 60)).padStart(2, "0")}:${String(Math.floor((s || 0) % 60)).padStart(2, "0")}`;

  return (
    <section className="px-6 py-16 max-w-7xl mx-auto" data-testid="trending-strip">
      <div className="flex items-end justify-between mb-8 gap-6">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF2A6D] mb-3 flex items-center gap-2"><TrendingUp className="w-3 h-3"/> // Trending</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight">Hot sets right now</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sets.slice(0, 6).map((s, i) => (
          <Link key={s.id} to={`/set/${s.id}`} data-testid={`trending-set-${s.id}`}
            className="group p-5 rounded-xl border border-[#1E2638] bg-[#121620] hover:border-[#FF2A6D] hover:bg-[#FF2A6D]/5 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div className="font-display font-black text-3xl text-transparent bg-clip-text bg-gradient-to-br from-[#00F0FF] to-[#FF2A6D]">#{i + 1}</div>
              <div className="flex items-center gap-1 text-xs font-mono text-[#FF8C00]"><Flame className="w-3 h-3"/> {s.reaction_count || 0}</div>
            </div>
            <div className="font-bold text-lg truncate group-hover:text-white mb-1">{s.name}</div>
            <div className="text-xs text-[#94A3B8] mb-3">by {s.artist_name}</div>
            <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-[#94A3B8]">
              <span className="flex items-center gap-1"><Music4 className="w-3 h-3"/> {(s.tracklist || []).length} tracks</span>
              <span>· {fmt(s.duration_seconds)}</span>
              <span>· {s.play_count} plays</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
